/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */

import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseAdditionalFormElement
	from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/BaseAdditionalFormElement";

export default class FormElementTitle extends BaseAdditionalFormElement {


	constructor(title = null, description = null) {
		super(FormElementType.TITLE);
		this.title = title
		this.description = description
	}

	resetElement() {
		super.resetElement();
		this.showDescription = true
		this.showRequiredSwitch = false
		this.placeholder = "Title"
	}

}
